import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import SortableHeaderCell from 'components/SortableHeaderCell';

const NameCell = ({data, column, meet, style}) => {
  const lifter = data;
  if(lifter.row === 'header') {
    return (<SortableHeaderCell style={style} column={column}/>);
  } else {
    const value = _.get(lifter, 'membershipStatus');
    return (
      <div style={style} className="ellipsis table-cell-inner">
        { value &&
          <div>
            <span className={classNames({'error': value !== 'OK' && value !== 'Active'})}>{ value }</span>
          </div>
        }
      </div>
    );
  }
};

export default NameCell;
